<div>
  <div>
    <div class="mb20">
      <span class="step-counter">Step {{1}}/{{3}}</span>
    </div>
    <div class="ds-input-wrap mb9">
      <h4>
        <span class="ds-input-label big mb20"><b>Please select your store type</b></span>
      </h4>
      <ds-dropdown
        [value]="selectedStoreType"
        [smallSize]="true"
        [dsDropdownOptions]="storeTypesForView"
        [showDropDown]="false"
        [dsDropdownWithSearchIcon]="true"
        dsDropdownPlaceHolder="Search your store type"
        [dsDropdownSearch]="true"
        [dsDropdownWithArrowIcon]="false"
        (onOptionChoose)="selectStoreType($event)"
        (searchOutside)="searchCategory($event)"
      ></ds-dropdown>
    </div>
  </div>

  <div class="create-ai-assistant-form-view__action-wrap first-step">
    <div class="db-navigation-text">
      <span class="back-to-previous pr8" (click)="backToPreviousStep()">Back</span>
    </div>

    <button class="ds-btn-black rectangle"
            [ngClass]="{'ds-btn-disabled': !selectedStoreType}"
            (click)="proceedToNextQuestion()">
      <span>Next</span>
    </button>

  </div>
</div>

<div class="create-ai-image-wrap">
  <div class="create-ai-image-1">
      <img src="assets/images/ai/onboarding/ai-store-dark.svg" alt="">
  </div>
  <div class="create-ai-image-2">
      <img src="assets/images/ai/onboarding/ai-store-dark-full.png" alt="">
  </div>
</div>
